import infoIcon from "src/assets/icons/how-to-buy/info.svg";
import discussIcon from "src/assets/icons/how-to-buy/discuss.svg";
import finaliseIcon from "src/assets/icons/how-to-buy/finalise.svg";
import { howToBuyTrns } from "../trns";

export const HOW_TO_BUY_ITEMS = [
  {
    id: 1,
    icon: infoIcon,
    label: {
      i18nKey: howToBuyTrns.infoLinkLabel,
    },
    href: '/',
  },
  {
    id: 2,
    icon: discussIcon,
    label: {
      i18nKey: howToBuyTrns.discussLinkLabel,
    },
    href: '/',
  },
  {
    id: 3,
    icon: finaliseIcon,
    label: {
      i18nKey: howToBuyTrns.finaliseLinkLabel,
    },
    href: '/',
  },
]